import PdaTitle from '../../component/common/PdaTitle'
import React, { useContext, useRef, useState } from 'react'
import { InputText } from 'primereact/inputtext'
import { CommonContext } from '../../component/common/context/commonContext'
import { getContentSize } from '../../utils/screenUtils'
import { useMountEffect } from 'primereact/hooks'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { tokens } from 'locales/tokens'

const InventoryList = () => {
    const { $http } = useContext(CommonContext)
    const { t } = useTranslation()
    const scanRef = useRef<HTMLInputElement>(null)
    const [searchText, setSearchText] = useState<string>('')
    const [height, setHieght] = useState<number>(getContentSize())
    const navigate = useNavigate()

    useMountEffect(() => {
        if (scanRef && scanRef.current) {
            scanRef.current.focus()
        }

        setHieght(getContentSize())
    })

    const existsLocation = async () => {
        /**
         * 2023-10-01 조현근
         * 로케이션을 등록할때, 이미 등록 된 녀석들도 포함 할 것인가? 협의 필요
         * 1. 포함 된다면 현재 기본정보를 불러오는 API 동시 호출해야함
         * @GetMapping("/location/{lctSeq}")
         * @Operation(summary = "로케이션 정보 조회", description = "로케이션 정보를 조회하는 API")
         * 2. 포함 되지 않는다면 lctSeq와 brcdSeq만 등록되어 있는 자료 필요(현재는 모두 not null)
         */
        setSearchText('')
        const result = await $http().get(`/inventory/check-location/${searchText}`)

        if (result) {
            navigate(`/location-save`, { state: { lctSeq: searchText } })
        }

        scanRef.current?.focus()
    }

    const onKeyDownSearch = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter') {
            existsLocation()
        }
    }

    return (
        <>
            <PdaTitle title={t(tokens.inventory.register_location)} historyBack goToHome />
            <div className="pda-search p-2">
                <div className="col-12 flex">
                    <InputText
                        ref={scanRef}
                        value={searchText}
                        className="p-inputtext-md w-full"
                        placeholder={t(tokens.inventory.enter_location_label_code_or_scan_barcode)}
                        onChange={(e) => setSearchText(e.currentTarget.value)}
                        onKeyDown={(e) => onKeyDownSearch(e)}
                    />
                </div>
            </div>
            <div className="px-2">
                <div className="font-bold text-center w-full vertical-align-middle" style={{ paddingTop: height / 3 }}>
                    {t(tokens.inventory.please_scan_location_barcode)}
                </div>
            </div>
        </>
    )
}

export default InventoryList
